import { runInAction } from 'mobx'
import { type IResponseEventMessage } from 'entities/Message'
import { Conversation } from 'entities/Conversation/model/Conversation'
import { Message } from 'entities/Message/model/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { checkFilterSmartView } from 'entities/SmartViews/lib/checkFilterSmartView'
import type { ILocalTypeInbox } from 'entities/Inbox'
import { useEventMessageReceivedNewGlobal } from 'entities/Conversation/events/EventMessageReceivedNewGlobal'
import {
  canAddConversationToList,
  type ConversationListStore,
} from 'pages/conversations/ui/ConversationList'

export const useEventMessageReceivedNew = (
  conversationListStore: ConversationListStore,
  view: ILocalTypeInbox
) => {
  const entities = useEntitiesContext()
  const { conversationStore } = entities

  const handler = (data: IResponseEventMessage) => {
    const item = new Conversation(data.conversation, entities)
    const message = new Message(
      {
        message: data.message,
      },
      entities
    )
    const { conversationSearchStore, filtersStore } = conversationListStore
    const update = () => {
      conversationStore.updateItem(data.conversation)
      conversationStore.getItem(data.conversation.id)?.handleChecked(item.checked)
      conversationListStore.updateItemOrder(item.id, 0, true)
    }

    runInAction(() => {
      // Smart view
      if (view === 'smart_view') {
        const smartView = entities.inboxesStore.localInboxes.currentSmartView

        if (!smartView) return
        if (!checkFilterSmartView(item.smartViewFilterParams, smartView.filters)) return
        if (!filtersStore.isShowConversation(item, message)) return

        update()

        return
      }

      // Default
      if (conversationSearchStore.isActive) return
      if (!filtersStore.isShowConversation(item, message)) return

      if (canAddConversationToList(data.conversation, entities)) {
        update()
      }
    })
  }

  useEventMessageReceivedNewGlobal(handler, [view])
}
